import Component from '@glimmer/component';

export default class MwRocketPlaceholder extends Component {}
